import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from 'feather-icons-react';
import { toast } from "react-toastify";

class  YearForm extends Component{

    state = {
        id : "",
        scolary_one : "",
        scolary_two : "",
        status : 1,
        errors : {},
        
        isModal : false,
        title : "",
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    storeYear = () =>{
        var data = {
                year : this.state.scolary_one && this.state.scolary_two ? this.state.scolary_one + "/"+ this.state.scolary_two : null,
                status : Number(this.state.status),
            }

        var request = this.state.id ? axios.put('years/'+this.state.id, data) : axios.post('years', data);
        request.then((response) =>{
            this.props.showModal()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error) => {
            this.setState({
                errors : error.response?.data?.errors || {}
            })
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }
    
    edit=()=>  {
        this.form()
    }

    form=()=>{
        const year = this.props.formData?.year || this.props.formData?.scolary_year || "";
        const [scolary_one = "", scolary_two = ""] = year.split("/");

        this.setState({
            id: this.props.formData ? this.props.formData.id : "",
            scolary_one,
            scolary_two,
            status: this.props.formData?.status !== undefined ? Number(this.props.formData.status) : 1,
            title : this.props.formData ? "Modifier l'année" : "Ajouter l'année",
            errors : {},
        })
    }

    showModal = () => {
        this.setState({
            isModal : !this.state.isModal,
        })
    }

    render(){
        
        return(
            <div>
            <Modal 
                show={this.props.isModal} 
                onHide={this.props.showModal}
                size="lg"
                onEntered={this.edit}
                backdrop={"static"}
                centered
                contentClassName="school-year-form">
                <Modal.Header className="school-year-form__header" closeButton>
                    <div className="school-year-form__title-icon">
                        <FeatherIcon icon="calendar" size={21} />
                    </div>
                    <div>
                        <span className="school-year-eyebrow">Organisation académique</span>
                        <Modal.Title>{ this.state.title}</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body className="school-year-form__body">
                    <div className="school-year-form__intro">
                        <strong>Définissez la période scolaire</strong>
                        <small>Renseignez les deux années et choisissez son état.</small>
                    </div>

                    <div className="school-year-form__section">
                        <label htmlFor="school-year-start">Année scolaire</label>
                        <div className="school-year-form__period">
                            <div className="school-year-form__field">
                                <FeatherIcon icon="calendar" size={17} />
                                <input type="number" min="1900" max="2200" className="form-control" placeholder="2025" onChange={this.handleInput} name="scolary_one" value={this.state.scolary_one} id="school-year-start" />
                            </div>
                            <span>à</span>
                            <div className="school-year-form__field">
                                <FeatherIcon icon="calendar" size={17} />
                                <input type="number" min="1900" max="2200" className="form-control" placeholder="2026" onChange={this.handleInput} name="scolary_two" value={this.state.scolary_two} id="school-year-end" />
                            </div>
                        </div>
                        <span className="school-year-form__error">{ this.state.errors.year || this.state.errors.scolary_year }</span>
                    </div>

                    <div className="school-year-form__section">
                        <label>Statut</label>
                        <div className="school-year-form__statuses">
                            <label className={Number(this.state.status) === 1 ? "is-selected is-active" : ""}>
                                <input type="radio" name="status" value="1" checked={Number(this.state.status) === 1} onChange={this.handleInput} />
                                <span className="school-year-form__status-icon"><FeatherIcon icon="check-circle" size={18} /></span>
                                <span><strong>Actif</strong><small>L'année est disponible et en cours.</small></span>
                                <i />
                            </label>
                            <label className={Number(this.state.status) === 0 ? "is-selected is-archived" : ""}>
                                <input type="radio" name="status" value="0" checked={Number(this.state.status) === 0} onChange={this.handleInput} />
                                <span className="school-year-form__status-icon"><FeatherIcon icon="archive" size={18} /></span>
                                <span><strong>Archivé</strong><small>L'année reste consultable uniquement.</small></span>
                                <i />
                            </label>
                        </div>
                        <span className="school-year-form__error">{ this.state.errors.status }</span>
                    </div>
                </Modal.Body>
                <Modal.Footer className="school-year-form__footer">
                    <button type="button" onClick={this.props.showModal} className="school-year-form__cancel"><FeatherIcon icon="x" size={16} /> Annuler</button>
                    <button type="button" onClick={this.storeYear} className="school-year-form__save"><FeatherIcon icon="check" size={16} /> Enregistrer</button>
                </Modal.Footer>
            </Modal>
            
 
        </div>
        )
    }
}
export default YearForm;
